import { render, staticRenderFns } from "./AIChatWidgetPdpTemplateLightbox.vue?vue&type=template&id=6f932c63&scoped=true"
import script from "./AIChatWidgetPdpTemplateLightbox.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetPdpTemplateLightbox.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetPdpTemplateLightbox.vue?vue&type=style&index=0&id=6f932c63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f932c63",
  null
  
)

export default component.exports